import React from 'react';
import './c28_accordion_ui.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {isMobileOnly} from "react-device-detect";
import Scrollbar from "react-scrollbars-custom";

class AccordionUI extends TemplateComponent {
    constructor(props) {
        super(props);
        this.state = {
            block1: false,
            block2: false
        };
        this.requireInternationalization = true;
    }

    toggle = (index) => () => {
        this.setState({[`block${index}`]: !this.state[`block${index}`]});
    }

    internationalComponentRender(data, t) {
        return (
            <div id="accordion-ui">
                <div className="accordion-ui-title">{data.class_id}</div>
                <div
                    className={!isMobileOnly ? 'container-fluid accordion-container' : 'container-fluid accordion-container-mob'}>
                    <div className="row accordion-row">
                        <div className="col accordion">
                            {data.semesters.map((semester, index) => (
                                <div key={index}>
                                    <dt className={(this.state[`block${index + 1}`]) ? 'title is-expanded' : 'title'}
                                        onClick={this.toggle(index + 1)}>{semester.title}</dt>
                                    <dd className={(this.state[`block${index + 1}`]) ? 'content is-expanded' : 'content'}
                                        onClick={this.toggle(index + 1)}>
                                        <div className="container-fluid">
                                            {isMobileOnly ? <Scrollbar style={{width: 640, height: 280}}>
                                                    <div className="row">
                                                        <ul className="col">
                                                            <li className="table-title">{t("C28 - First Column")}</li>
                                                            <li>{semester.class_fields.map((course, element) => (
                                                                <div key={element}
                                                                     className="table-row">{course.course}</div>
                                                            ))}</li>
                                                        </ul>

                                                        <ul className="col ">
                                                            <li className="table-title">{t("C28 - Second Column")}</li>
                                                            <li>{semester.class_fields.map((course, element) => (
                                                                <div key={element} className="table-row">{course.SSD}</div>
                                                            ))}</li>
                                                        </ul>

                                                        <ul className="col">
                                                            <li className="table-title">{t("C28 - Third Column")}</li>
                                                            <li>{semester.class_fields.map((course, element) => (
                                                                <div key={element}
                                                                     className="table-row">{course.credits}</div>
                                                            ))}</li>
                                                        </ul>
                                                    </div>
                                                </Scrollbar> :
                                                <div className="row">
                                                    <ul className="col">
                                                        <li className="table-title">{t("C28 - First Column")}</li>
                                                        <li>{semester.class_fields.map((course, element) => (
                                                            <div key={element}
                                                                 className="table-row">{course.course}</div>
                                                        ))}</li>
                                                    </ul>
                                                    <ul className="col ">
                                                        <li className="table-title">{t("C28 - Second Column")}</li>
                                                        <li>{semester.class_fields.map((course, element) => (
                                                            <div key={element} className="table-row">{course.SSD}</div>
                                                        ))}</li>
                                                    </ul>
                                                    <ul className="col">
                                                        <li className="table-title">{t("C28 - Third Column")}</li>
                                                        <li>{semester.class_fields.map((course, element) => (
                                                            <div key={element}
                                                                 className="table-row">{course.credits}</div>
                                                        ))}</li>
                                                    </ul>
                                                </div>}
                                        </div>
                                    </dd>
                                </div>))}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AccordionUI;

